__turbopack_context__.v({
  "action": "CategoryNavigation-module-scss-module__z6r1BG__action",
  "bar": "CategoryNavigation-module-scss-module__z6r1BG__bar",
  "button": "CategoryNavigation-module-scss-module__z6r1BG__button",
  "chips": "CategoryNavigation-module-scss-module__z6r1BG__chips",
});
